import colors from 'tailwindcss/colors';
import { customColors } from 'src/shared/lib/tailwind-colors';

type DeprecatedColor = 'lightBlue' | 'warmGray' | 'trueGray' | 'coolGray' | 'blueGray';

const deprecatedNames = new Set<string>(['lightBlue', 'warmGray', 'trueGray', 'coolGray', 'blueGray']);

const safeColors = Object.fromEntries(Object.entries(colors).filter(([key]) => !deprecatedNames.has(key))) as Omit<
  typeof colors,
  DeprecatedColor
>;

export const twColors = { ...safeColors, ...customColors };
